import { defineEvent } from "@visioni/a3s-analytics";
import type { NotificationCategory, NotificationChannel } from "@visioni/a3s-notifications/app";
import type { RequestErrorType } from "@src/services/api/error-type";

export type NotificationPreferenceChange = {
  tenant_id: string | undefined;
  level: "all_cameras" | "site" | "camera";
  site_id?: string | undefined;
  camera_key?: string | undefined;
  category: NotificationCategory;
  channel: NotificationChannel;
  enabled: boolean;
};

export const NotificationPreferenceSaved = defineEvent<NotificationPreferenceChange>("Notification Preference Saved");
export const NotificationPreferenceFailed = defineEvent<
  NotificationPreferenceChange & { error_type: RequestErrorType }
>("Notification Preference Failed");

/** The SMS number for notifications was set or cleared. Never the number itself. */
type PhoneNumberChange = { tenant_id: string | undefined; action: "set" | "removed" };
export const NotificationPhoneNumberSaved = defineEvent<PhoneNumberChange>("Notification Phone Number Saved");
export const NotificationPhoneNumberFailed = defineEvent<PhoneNumberChange & { error_type: RequestErrorType }>(
  "Notification Phone Number Failed",
);

/** Continue / Skip on the push onboarding screen; `push_enabled: false` means skipped. */
export const PushNotificationsOnboardingCompleted = defineEvent<{
  push_enabled: boolean;
  os_permission_denied: boolean;
}>("Push Notifications Onboarding Completed");
